export enum BdpkSchedulePeriodEnum {
  ONCE = 1,
  DAILY = 2,
  WEEKLY = 3,
  MONTHLY = 4
}

export interface BdpkSchedulePeriodType {
  id: number;
  name: string;
}

export const BdpkSchedulePeriodTypes: ReadonlyMap<BdpkSchedulePeriodEnum, BdpkSchedulePeriodType> = new Map([
  [BdpkSchedulePeriodEnum.ONCE, { id: 1, name: 'однократно' }],
  [BdpkSchedulePeriodEnum.DAILY, { id: 2, name: 'ежедневно' }],
  [BdpkSchedulePeriodEnum.WEEKLY, { id: 3, name: 'еженедельно' }],
  [BdpkSchedulePeriodEnum.MONTHLY, { id: 4, name: 'ежемесячно' }]
]);
